import api from "services/api";

export const fetchCategory = async (
  categoryType?: number[]
): Promise<Category[]> => {
  const response = await categoryService.getCategories(categoryType);
  return response.data;
};

const categoryService = {
  getCategories(categoryType?: number[]) {
    const params =
      categoryType !== undefined ? { category_type: categoryType } : {};
    return api.get("/category", { params });
  },
};

export default categoryService;

// export interface Category {
//   id: number;
//   category: string;
//   description: string;
//   icon_uri?: string;
//   display_order: number;
//   category_type: number;
// }

export interface Category {
  id: number;
  category: string;
  description: string;
  icon_uri: string;
  category_type: number;
}
